<div class="flex items-start justify-between gap-sm rounded-1 bg-grey-50 p-md shadow-1 sm:max-w-96">
  <div class="flex items-center gap-md overflow-x-hidden">
    <fa-icon [icon]="icon()" class="text-xl"></fa-icon>
    <div>
      <ng-content></ng-content>
    </div>
  </div>
  <fa-icon
    [icon]="editIcon"
    class="cursor-pointer"
    [routerLink]="editPath()"
    [fragment]="fragment()"
    queryParamsHandling="merge"
  ></fa-icon>
</div>
